import { z } from "zod";

export type SandboxInfo = z.infer<typeof SandboxInfoSchema>;
export const SandboxInfoSchema = z.object({
  can_create_sandbox: z.boolean(),
  exists: z.boolean(),
  prd_tenant_id: z.number().nullable(),
  sandbox_tenant_id: z.number().nullable(),
  created_at: z.string().nullable(),
  created_user_name: z.string().nullable(),
  last_updated_at: z.string().nullable(),
  last_updated_user_name: z.string().nullable(),
  note: z.string().nullable(),
});

export type SandboxCount = z.infer<typeof SandboxCountSchema>;
export const SandboxCountSchema = z.object({
  count: z.number(),
});
